/* eslint-disable no-new */
import Vue from 'vue';
import TranslatePlugin from '../shared/TranslatePlugin';
import ComponentInitializer from '../shared/ComponentInitializer';
import VarietyAdvisor from './variety-advisor.vue';
import VarietyComparison from './variety-comparison.vue';

Vue.use(TranslatePlugin);
Vue.config.productionTip = false;

ComponentInitializer.initVueComponents([
  { component: VarietyAdvisor, dataAttribute: 'data-variety-advisor' },
  { component: VarietyComparison, dataAttribute: 'data-variety-comparison' },
]);
